<script>
import MileCountdown from '@components/mile-countdown.vue'
export default {
  page: {
    title: 'Mile Countdown',
  },
  components: {
    MileCountdown,
  },
  data() {
    return {}
  },
  methods: {},
}
</script>

<template>
  <div>
    <div :class="$style.container"> <MileCountdown :height="400" /></div>
    <div :class="$style.container2"> <MileCountdown :height="200" /></div>
    <div :class="$style.container3"> <MileCountdown :height="104" /></div>
  </div>
</template>

<style lang="scss" module>
@import '@design';
.container {
  width: 1200px;
  height: 400px;
}

.container2 {
  width: 600px;
  height: 200px;
}

.container3 {
  width: 312px;
  height: 104px;
}
</style>
